var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('card',{staticClass:"card-login card-white"},[_c('Header',{attrs:{"pageTitle":"Welcome to AGATRS!"}}),_c('hr'),_vm._v(" "+_vm._s(_vm.htmlstr)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }